import Consumer from './AuthableConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'authable')
